export default {
  filters: {
    priceFormat (totalAmount, roundingType = 0,currency = null) {
      totalAmount = parseFloat(totalAmount).toFixed(2)

      const rounding_type = parseInt(roundingType)
      const number = parseFloat(totalAmount)

      if(Number.isInteger(totalAmount) || rounding_type == 0 || number == 0.00) {
        if(currency !== null){
          let format = 'th-TH'
          switch (currency) {
            case 'EUR':
              format = 'de-DE'
              break;
            default:
              format = 'th-TH'
              break;
          }
          return new Intl.NumberFormat(format, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(number)
        }
        
          return number
      }

      let decimal    =   (number * 100) - (Math.floor(number) * 100)
      let result     =   number

      switch(rounding_type) {
        case 1: // up 1
          result = Math.ceil(number)
        break
        case 2: // up 0.50
          if (decimal > 50)     result =    Math.floor(number) + 1
          else if (decimal > 0) result =    Math.floor(number) + 0.50
        break
        case 3: // up 0.25
          if(decimal > 75)      result =    Math.floor(number) + 1
          else if(decimal > 50) result =    Math.floor(number) + 0.75
          else if(decimal > 25) result =    Math.floor(number) + 0.50
          else if(decimal > 0)  result =    Math.floor(number) + 0.25
        break
        case 4: // down 1
          result = Math.floor(number)
          break
        case 5: // down 0.50
          if(decimal < 50)      result =    Math.floor(number)
          else                  result =    Math.floor(number) + 0.50
          break
        case 6: // down 0.25
          if(decimal < 25)      result =    Math.floor(number)
          else if(decimal < 50) result =    Math.floor(number) + 0.25
          else if(decimal < 75) result =    Math.floor(number) + 0.50
          else                  result =    Math.floor(number) + 0.75
          break
        case 7: // up 0.10
          if(decimal > 90)       result =   Math.floor(number) + 1
          else if(decimal > 80)  result =   Math.floor(number) + 0.90
          else if(decimal > 70)  result =   Math.floor(number) + 0.80
          else if(decimal > 60)  result =   Math.floor(number) + 0.70
          else if(decimal > 50)  result =   Math.floor(number) + 0.60
          else if(decimal > 40)  result =   Math.floor(number) + 0.50
          else if(decimal > 30)  result =   Math.floor(number) + 0.40
          else if(decimal > 20)  result =   Math.floor(number) + 0.30
          else if(decimal > 10)  result =   Math.floor(number) + 0.20
          else if(decimal > 0)   result =   Math.floor(number) + 0.10
          break
      case 8: // up 0.05
          if(decimal > 95)       result =   Math.floor(number) + 1
          else if(decimal > 90)  result =   Math.floor(number) + 0.95
          else if(decimal > 85)  result =   Math.floor(number) + 0.90
          else if(decimal > 80)  result =   Math.floor(number) + 0.85
          else if(decimal > 75)  result =   Math.floor(number) + 0.80
          else if(decimal > 70)  result =   Math.floor(number) + 0.75
          else if(decimal > 65)  result =   Math.floor(number) + 0.70
          else if(decimal > 60)  result =   Math.floor(number) + 0.65
          else if(decimal > 55)  result =   Math.floor(number) + 0.60
          else if(decimal > 50)  result =   Math.floor(number) + 0.55
          else if(decimal > 45)  result =   Math.floor(number) + 0.50
          else if(decimal > 40)  result =   Math.floor(number) + 0.45
          else if(decimal > 35)  result =   Math.floor(number) + 0.40
          else if(decimal > 30)  result =   Math.floor(number) + 0.35
          else if(decimal > 25)  result =   Math.floor(number) + 0.30
          else if(decimal > 20)  result =   Math.floor(number) + 0.25
          else if(decimal > 15)  result =   Math.floor(number) + 0.20
          else if(decimal > 10)  result =   Math.floor(number) + 0.15
          else if(decimal > 5)   result =   Math.floor(number) + 0.10
          else if(decimal > 0)   result =   Math.floor(number) + 0.05
          break
      case 9: // down 0.10
          if(decimal < 10)       result =   Math.floor(number)
          else if(decimal < 20)  result =   Math.floor(number) + 0.10
          else if(decimal < 30)  result =   Math.floor(number) + 0.20
          else if(decimal < 40)  result =   Math.floor(number) + 0.30
          else if(decimal < 50)  result =   Math.floor(number) + 0.40
          else if(decimal < 60)  result =   Math.floor(number) + 0.50
          else if(decimal < 70)  result =   Math.floor(number) + 0.60
          else if(decimal < 80)  result =   Math.floor(number) + 0.70
          else if(decimal < 90)  result =   Math.floor(number) + 0.80
          else                   result =   Math.floor(number) + 0.90
          break
      case 10: // down 0.05
          if(decimal < 5)        result =   Math.floor(number)
          else if(decimal < 10)  result =   Math.floor(number) + 0.05
          else if(decimal < 15)  result =   Math.floor(number) + 0.10
          else if(decimal < 20)  result =   Math.floor(number) + 0.15
          else if(decimal < 25)  result =   Math.floor(number) + 0.20
          else if(decimal < 30)  result =   Math.floor(number) + 0.25
          else if(decimal < 35)  result =   Math.floor(number) + 0.30
          else if(decimal < 40)  result =   Math.floor(number) + 0.35
          else if(decimal < 45)  result =   Math.floor(number) + 0.40
          else if(decimal < 50)  result =   Math.floor(number) + 0.45
          else if(decimal < 55)  result =   Math.floor(number) + 0.50
          else if(decimal < 60)  result =   Math.floor(number) + 0.55
          else if(decimal < 65)  result =   Math.floor(number) + 0.60
          else if(decimal < 70)  result =   Math.floor(number) + 0.65
          else if(decimal < 75)  result =   Math.floor(number) + 0.70
          else if(decimal < 80)  result =   Math.floor(number) + 0.75
          else if(decimal < 85)  result =   Math.floor(number) + 0.80
          else if(decimal < 90)  result =   Math.floor(number) + 0.85
          else if(decimal < 95)  result =   Math.floor(number) + 0.90
          else                   result =   Math.floor(number) + 0.95
          break
      case 11: // Nearest 1
          if(decimal < 50)       result =   Math.floor(number)
          else                   result =   Math.ceil(number)
          break;
      case 12: // Nearest 0.5
          if(decimal < 25)       result = Math.floor(number)
          else if (decimal < 75) result = Math.floor(number) + 0.5
          else                   result = Math.ceil(number)
          break
      case 13: // Nearest 0.25
          if(decimal < 12.5)         result = Math.floor(number)
          else if(decimal < 37.5)    result = Math.floor(number) + 0.25
          else if(decimal < 62.5)    result = Math.floor(number) + 0.50
          else if(decimal < 87.5)    result = Math.floor(number) + 0.75
          else                       result = Math.ceil(number)
          break
      case 14: // Nearest 0.10
          if(decimal < 5)            result = Math.floor(number)
          else if(decimal < 15)      result = Math.floor(number) + 0.1
          else if(decimal < 25)      result = Math.floor(number) + 0.2
          else if(decimal < 35)      result = Math.floor(number) + 0.3
          else if(decimal < 45)      result = Math.floor(number) + 0.4
          else if(decimal < 55)      result = Math.floor(number) + 0.5
          else if(decimal < 65)      result = Math.floor(number) + 0.6
          else if(decimal < 75)      result = Math.floor(number) + 0.7
          else if(decimal < 85)      result = Math.floor(number) + 0.8
          else if(decimal < 95)      result = Math.floor(number) + 0.9
          else                       result = Math.ceil(number)
          break
      case 15: // Nearest 0.05
          if(decimal < 2.5)          result = Math.floor(number)
          else if(decimal < 7.5)     result = Math.floor(number) + 0.05
          else if(decimal < 12.5)    result = Math.floor(number) + 0.1
          else if(decimal < 17.5)    result = Math.floor(number) + 0.15
          else if(decimal < 22.5)    result = Math.floor(number) + 0.2
          else if(decimal < 27.5)    result = Math.floor(number) + 0.25
          else if(decimal < 32.5)    result = Math.floor(number) + 0.3
          else if(decimal < 37.5)    result = Math.floor(number) + 0.35
          else if(decimal < 42.5)    result = Math.floor(number) + 0.4
          else if(decimal < 47.5)    result = Math.floor(number) + 0.45
          else if(decimal < 52.5)    result = Math.floor(number) + 0.5
          else if(decimal < 57.5)    result = Math.floor(number) + 0.55
          else if(decimal < 62.5)    result = Math.floor(number) + 0.6
          else if(decimal < 67.5)    result = Math.floor(number) + 0.65
          else if(decimal < 72.5)    result = Math.floor(number) + 0.7
          else if(decimal < 77.5)    result = Math.floor(number) + 0.75
          else if(decimal < 82.5)    result = Math.floor(number) + 0.8
          else if(decimal < 87.5)    result = Math.floor(number) + 0.85
          else if(decimal < 92.5)    result = Math.floor(number) + 0.9
          else if(decimal < 97.5)    result = Math.floor(number) + 0.95
          else                       result = Math.ceil(number)
          break
        default:
          break
      }

      // Price Format
      if(currency !== null){
        let format = 'th-TH'
        switch (currency) {
          case 'EUR':
            format = 'de-DE'
            break;
          default:
            format = 'th-TH'
            break;
        }
        return new Intl.NumberFormat(format, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(result)
      }
      

      if (Number(result).toFixed(2).split(".")[1] == "00") {
        result = Number(Number(result).toFixed(2)).toString()
      } else {
        result = Number(Number(result).toFixed(2)).toFixed(2)
      }
      result = Number(result).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      return result
    },
    filterDayTH (value) {
      let arrDay = [ 'อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.' ]
      return arrDay[value]
    },
    // filterLongDayTH (day) {
    //   let arrDay = [ 'อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์' ]
    //   return arrDay[day]
    // },
    filterDayEN (value) {
      let arrDay = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ]
      return arrDay[value]
    }
    // filterLongDayEN (day) {
    //   let arrDay = [ 'Sunday', 'Monday', 'Tueday', 'Wednesday', 'Thursday', 'Friday', 'Saturday' ]
    //   return arrDay[day]
    // }
  },
  methods: {
    convertDateTime () {
      const date = new Date()
      let hours = ('0' + date.getHours()).slice(-2)
      let minutes = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
      return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + hours + ':' + minutes
    },
    isToday (datetime) {
      let strdate = datetime.substr(0, 10)
      let splitDate = strdate.split('/')
      const today = new Date()
      const date = new Date(splitDate[2], splitDate[1], splitDate[0])
      return date.getDate() === today.getDate() && (date.getMonth()) === (today.getMonth() + 1) && date.getFullYear() === today.getFullYear()
    },
    isTodayFormat (datetime) {
      const today = new Date()
      const date = new Date(datetime)
      return date.getDate() === today.getDate() && (date.getMonth() + 1) === (today.getMonth() + 1) && date.getFullYear() === today.getFullYear()
    },
    filter_short_month_en (datetime) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const d = new Date(datetime)
      return monthNames[d.getMonth()]
    },
    filter_short_day_en (datetime) {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      const d = new Date(datetime)
      return days[d.getDay()]
    },
    filter_long_day_th (day) {
      let arrDay = [ 'อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัส', 'ศุกร์', 'เสาร์' ]
      return arrDay[day]
    },
    filter_long_day_en (day) {
      let arrDay = [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ]
      return arrDay[day]
    },
    // filter_day_th (value) {
    //   let arrDay = [ 'อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.' ]
    //   return arrDay[value]
    // },
    showPreOrderDateTime (strdate, strtime) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let splitDate = strdate.split(' ')
      let day = splitDate[1]
      let month = monthNames.indexOf(splitDate[2])
      let date = new Date(Number(splitDate[3]), month, day)
      let textdate = (this.$i18n.locale == 'en') ? this.filter_long_day_en(date.getDay()) + ', '+ ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + strtime : this.filter_long_day_th(date.getDay()) + ', '+ ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + strtime
      return (this.isTodayFormat(date)) ? 'Today, '+ ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear() + ' ' + strtime  : textdate
    },
    getFormatPreOrderDateTime (strdate, strtime) {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let splitDate = strdate.split(' ')
      let day = splitDate[1]
      let month = monthNames.indexOf(splitDate[2])
      let date = new Date((new Date()).getFullYear(), month, day)
      return Number(splitDate[3]) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + strtime
    },
    price_format (value,currency = null) {
      if(currency !== null){
        let format = 'th-TH'
        switch (currency) {
          case 'EUR':
            format = 'de-DE'
            break;
          default:
            format = 'th-TH'
            break;
        }
        return new Intl.NumberFormat(format, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(value)
      }
      

      if (Number(value).toFixed(2).split(".")[1] == "00") {
        var price = Number(Number(value).toFixed(2)).toString()
      } else {
        var price = Number(Number(value).toFixed(2)).toFixed(2)
      }
      return Number(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    replaceToNumber (value) {
      var reg = new RegExp('^\\d+$')
      if (reg.test(value)) {
        return value.replace(reg, value)
      } else {
        return value.substr(0, value.length - 1)
      }
    },
    replaceToCharactor (val) {
      var reg = new RegExp('^[a-zA-Z\\s]+$')
      if (reg.test(val)) {
        return val.replace(reg, val)
      } else {
        return val.substr(0, val.length - 1)
      }
    },
    getCardType (cardNumber) {
      let cardType = null
      if (cardNumber.substr(0, 1) === '4') {
        cardType = 1 // VISA
      }
      if (cardNumber.substr(0, 2) >= 51 && cardNumber.substr(0, 2) <= 55) {
        cardType = 2 // MASTER CARD
      }
      if (cardNumber.substr(0, 4) >= 2221 && cardNumber.substr(0, 4) <= 2720) {
        cardType = 2 // MASTER CARD
      }
      if (cardNumber.substr(0, 2) === 81) {
        cardType = 6 // UNION PAY
      }
      if (cardNumber.substr(0, 4) >= 3528 && cardNumber.substr(0, 4) <= 3589) {
        cardType = 4 // JCB
      }
      if (cardNumber.substr(0, 2) === 34 || cardNumber.substr(0, 2) === 37) {
        cardType = 7 // AMEX
      }
      return cardType
    },
    getImgCardType (cardNumber) {
      let ImgcardType = null
      if (cardNumber.substr(0, 1) === '4') {
        ImgcardType = 'icons/card/visa.png' // VISA
      }
      if (cardNumber.substr(0, 2) >= 51 && cardNumber.substr(0, 2) <= 55) {
        ImgcardType = 'icons/card/master-logo.png' // MASTER CARD
      }
      if (cardNumber.substr(0, 4) >= 2221 && cardNumber.substr(0, 4) <= 2720) {
        ImgcardType = 'icons/card/master-logo.png' // MASTER CARD
      }
      if (cardNumber.substr(0, 2) === 81) {
        ImgcardType = 'icons/card/unionpay.png' // UNION PAY
      }
      if (cardNumber.substr(0, 4) >= 3528 && cardNumber.substr(0, 4) <= 3589) {
        ImgcardType = 'icons/card/jcb.png' // JCB
      }
      if (cardNumber.substr(0, 2) === 34 || cardNumber.substr(0, 2) === 37) {
        ImgcardType = 'icons/card/master-logo.png' // AMEX
      }
      if (ImgcardType === null) {
        ImgcardType = ''
      }
      return ImgcardType
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/mixins.js